// extracted by mini-css-extract-plugin
export default {"wrap":"TaskForm_wrap__lY3d8","labelSection":"TaskForm_labelSection__PjTf1","input":"TaskForm_input__L5+fw","buttonsWrap":"TaskForm_buttonsWrap__Rpk29"};